module.exports = __webpack_public_path__ + "static/media/vinod_khosla_keynote.bfc78239.png";